import { createAssetManagementClient } from '@/shared/api/client'
import { validateCompositeResponse } from '@/shared/api/validation'

const client = createAssetManagementClient()

export const approveInvoice = (invoiceId: number) => validateCompositeResponse(
  client.sendPut(`billing/invoices/${invoiceId}/approvals`)
)
